import { render } from "./ControlSidebar.vue?vue&type=template&id=7f13fb38"
import script from "./ControlSidebar.vue?vue&type=script&lang=js"
export * from "./ControlSidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ad\\Downloads\\internship-project-todolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__